function getInformation() {
    return window.axios.get('/api/user/information');
}
export default {
    getInformation
}